import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './FixedContextMenu.scss'

export const FixedContextMenu = ({
  actionDiscard,
  actions,
  className,
  label,
  visible,
  'data-mu-test': dataAttributeTest
}) => {
  const handleClickDiscard = e => {
    e.preventDefault()
    if (typeof actionDiscard.onClick === 'function') {
      actionDiscard.onClick(e)
    }
  }

  return (
    <div
      className={classnames('b-fixed-context-menu', className, {
        'b-fixed-context-menu--visible': visible
      })}
      data-mu-test={classnames('fixed-context-menu', dataAttributeTest)}
    >
      <strong className='b-fixed-context-menu__label'>{label}</strong>
      {actions && (
        <ul className='b-fixed-context-menu__actions'>
          {actions.map((action, i) => {
            const handleClick = e => {
              e.preventDefault()
              if (typeof action.onClick === 'function') {
                action.onClick(e)
              }
            }

            return (
              <li
                key={`fixed-context-action-${i}`}
                className={classnames('b-fixed-context-menu__action', {
                  'b-fixed-context-menu__action--danger':
                    action.variant === 'danger'
                })}
                data-mu-test={action['data-mu-test']}
              >
                <a href='#' onClick={handleClick}>
                  {action.label}
                </a>
              </li>
            )
          })}
        </ul>
      )}
      {actionDiscard && (
        <a
          href='#'
          className='b-fixed-context-menu__discard'
          onClick={handleClickDiscard}
          data-mu-test={actionDiscard['data-mu-test']}
        >
          {actionDiscard.label}
        </a>
      )}
    </div>
  )
}

FixedContextMenu.propTypes = {
  actionDiscard: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    'data-mu-test': PropTypes.string
  }),
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      variant: PropTypes.string,
      'data-mu-test': PropTypes.string
    })
  ),
  className: PropTypes.string,
  label: PropTypes.string,
  visible: PropTypes.bool,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/ 'data-mu-test': PropTypes.string
}
